import { Component, Input, OnInit } from '@angular/core';
import { Tables } from '../../entities/tables';
import { GeneralDynamicContent } from '../../entities/general-dynamic-content';
import { DynamicDocumentService } from '../../services/dynamic-document.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModaleContentComponent } from './modale-content/modale-content.component';
import { TemplateService } from 'src/app/services/template.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ModalePreviewComponent } from './modale-preview/modale-preview.component';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { CustomTranslateService } from '../../services/custom-translate.service';

@Component({
  selector: 'app-dynamic-content',
  templateUrl: './dynamic-content.component.html',
  styleUrls: ['./dynamic-content.component.css']
})
export class DynamicContentComponent implements OnInit {

  @Input() public tab: Tables = new Tables();
  @Input() public value = '';
  status: any[];
  selectedStatus: any;
  order: number = 0;

  lecture = true;

  languages = environment.languages;
  selectedLang?: typeof environment.languages[0];

  dynamicContent: GeneralDynamicContent;


  constructor(private dynamicDocumentService: DynamicDocumentService,
    public dialog: MatDialog,
    private templateService: TemplateService,
    private httpClientService: HttpclientService,
    public translateService: CustomTranslateService) { }

  ngOnInit(): void {
    this.lecture = this.tab.value == 'lecture';
    if (this.lecture) {
      this.loadDynamicContent();
    } else {
      this.setDefaultContent();
    }

  }

  setDefaultContent() {

    this.dynamicContent = new GeneralDynamicContent();
    this.dynamicContent.layout = [];
    this.dynamicContent.content = [];
    this.selectedLang = this.languages.find(el => el.code === this.translateService.currentLang);
    this.loadStatus();
  }

  loadStatus() {
    this.templateService.getDropDownValues(`parametre/nomtable/CONTENT_STATUS`).subscribe((res: any) => {
      this.status = res;
      if (this.dynamicContent?.status) {
        this.selectedStatus = this.status.find((el: any) => el.id === this.dynamicContent.status.parameterId);
      } else {
        this.selectedStatus = this.status.find((el: any) => el.valeur === 'BROUILLON');
      }
    });
  }

  convertUrl() {
    const cleanedText = this.dynamicContent.reference.replace(/[^a-zA-Z0-9\s]/g, '');
    const url = cleanedText.split(' ').join('-').toLowerCase();
    this.dynamicContent.url = url;
  }

  loadDynamicContent() {
    this.dynamicDocumentService.findById(this.tab.entite, this.tab.id).subscribe((res: GeneralDynamicContent) => {
      this.dynamicContent = res;

      this.loadStatus()
      this.selectedLang = this.languages.find((el: any) => el.code === this.dynamicContent.lang);
    });
  }

  getDynamicContentValue(ref: string) {
    return this.dynamicContent?.content.find((el: any) => el.ref === ref)?.value;
  }

  save() {
    this.dynamicContent.creationDate = undefined;
    this.dynamicContent.updatingDate = undefined;
    this.dynamicContent.status = this.selectedStatus.id;
    if (this.selectedLang) this.dynamicContent.lang = this.selectedLang.code;
    this.dynamicDocumentService.saveDocument(this.tab.entite, this.dynamicContent).subscribe((res) => {
      if (res.id)
        this.dynamicContent = res;
      this.lecture = true;
    });
  }

  setImage(event: any) {
    let selectedFile = event.target.files[0];
    if (!selectedFile) {
      return;
    }
    this.uploadFile(selectedFile)
  }

  changeImageUrl(event: any) {
    this.dynamicContent.image = event.target.value;
  }

  uploadFile(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    this.httpClientService
      .postWithHeader(formData, {}, '/resource-files')
      .subscribe({
        next: (resourceFile) => {
          this.dynamicContent.image = [resourceFile];
        },
        error: (error) => {
          console.error('Error uploading image:', error);
        },
      });
  }

  addRow() {
    let newBlocRef = '#' + new Date().getTime();
    this.dynamicContent.content.push({ ref: newBlocRef, type: 'TEXT', value: null, content: null })
    this.dynamicContent.layout.push([{ column: 12, contentRef: newBlocRef }]);
  }

  addColumn(layout: any) {
    let newBlocRef = '#' + new Date().getTime();
    this.dynamicContent.content.push({ ref: newBlocRef, type: 'TEXT', value: null, content: null })
    layout.push({ column: 12, contentRef: newBlocRef });

    this.setColumns(layout);
  }

  setColumns(layout: any) {
    let maxColumns = 12;
    layout.map((el: any) => {
      el.column = maxColumns / layout.length;
    });
  }

  removeColumn(bloc: any, layout: any[], index: number) {
    layout = layout.filter((l: any) => l.contentRef !== bloc.contentRef);
    this.setColumns(layout);

    if (layout.length === 0) {
      this.removeRow(index);
    } else {
      this.dynamicContent.layout[index] = layout;
    }
  }

  duplicate() {
    this.dynamicContent.id = undefined;
    this.save();
  }

  openPreview() {
    this.dialog.open(ModalePreviewComponent, { data: this.dynamicContent })
  }

  removeRow(index: number) {
    this.dynamicContent.layout = this.dynamicContent.layout.filter((el: any, i: number) => i !== index);
  }

  editBloc(layout: any) {
    let contentElement = this.dynamicContent?.content.find((el: any) => el.ref === layout.contentRef);
    let dialogRef: MatDialogRef<ModaleContentComponent> = this.dialog.open(ModaleContentComponent, { data: contentElement });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (contentElement && result) {
        contentElement.value = result.blocValue;
        contentElement.type = result.contentType;
        contentElement.content = result.content;
        contentElement.ref = result.blocRef;
      }
    });
  }

  moveToRight(rowIndex: number, blocIndex: number) {
    moveItemInArray(this.dynamicContent.layout[rowIndex], blocIndex, blocIndex + 1);

  }

  moveUp(index: number) {
    moveItemInArray(this.dynamicContent.layout, index, index - 1);
  }

}
